export const toggleHamburger = (
  hamburgerButtonClassName,
  spMenuClassName,
  breakPoint
) => {
  const trigger = document.querySelector(`.${hamburgerButtonClassName}`);
  const menu = document.querySelector(`.${spMenuClassName}`);
  const links = document.querySelectorAll(`.${spMenuClassName} a`);

  if (!trigger || !menu) {
    return;
  }

  const pointHeader = window.matchMedia(
    `screen and (min-width: ${breakPoint}px)`
  );

  // バックグラウンドコンテンツ（メニュー開放時に inert にする対象）
  const backdrop = document.querySelectorAll(".l-main, .s-footer");

  // ハンバーガーボタンのクリックイベント
  trigger.addEventListener("click", (e) => {
    const isExpanded = e.currentTarget.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      closeMenu();
      trigger.focus();
    } else {
      openMenu();
    }
  });

  const openMenu = () => {
    trigger.setAttribute("aria-expanded", "true");
    trigger.setAttribute("aria-label", "メニューを閉じる");
    menu.inert = false;
    backdrop.forEach((el) => {
      el.inert = true;
    });
  };

  const closeMenu = () => {
    trigger.setAttribute("aria-expanded", "false");
    trigger.setAttribute("aria-label", "メニューを開く");
    menu.inert = true;
    backdrop.forEach((el) => {
      el.inert = false;
    });
  };

  // メニュー内のリンクをクリックしたら閉じる
  links.forEach((link) => {
    link.addEventListener("click", () => {
      closeMenu();
      trigger.focus();
    });
  });

  // Escapeキーでメニューを閉じる
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && trigger.getAttribute("aria-expanded") === "true") {
      closeMenu();
      trigger.focus();
    }
  });

  // ブレイクポイントをまたいだときにメニューを閉じる
  function checkBreakPoint() {
    if (pointHeader.matches) {
      closeMenu();
    }
  }

  pointHeader.addEventListener("change", checkBreakPoint);

  // 初回ロード時にメニューを閉じる
  closeMenu();
};
